app.component("appointmentsList", {
	templateUrl: "app/src/js/directives/appointmentsList.html",
	controller: "appointmentsListController",
	bindings: {
        data: "<",
		trigger: "&",
	},
});

app.controller("appointmentsListController", [
	"$scope",
	"$filter",
	"Session",
	"CurrentPatient",
	"TIMEZONE_TYPE",
	function ($scope, $filter,Session,CurrentPatient,TIMEZONE_TYPE) {
		$scope.Session = Session;
		this.$onInit = function () {
		   $scope.CP = CurrentPatient;
		   splitAppointments();
		}

		// The header fetches the list again each time the popover opens and when an appointment of this
		// patient changes, so an open popover has to take the new list rather than keep the one it opened with.
		this.$onChanges = function (changes) {
			if (changes.data) {
				splitAppointments();
			}
		}

		function splitAppointments() {
	       // The popover can open before the patient's appointments have come back.
	       $scope.appointments = $scope.$ctrl.data || [];
		   //  t.clinician_id !== Session.user.id
           // Parsed as UTC to match formatText and the rest of the codebase. Bare moment() parses in
           // the browser's timezone, which in NZ/AU shifts appointments ~12-13h and misclassifies ones
           // near "now" as past/future, rendering them the wrong colour.
           // Upcoming ones soonest first, so the first line is the next visit; past ones latest first.
           $scope.pastAppointments = $scope.appointments.filter(t=>moment.utc(t.start_date_utc).isBefore(moment())).sort((a,b)=>moment.utc(b.start_date_utc) - moment.utc(a.start_date_utc));
           $scope.futureAppointments = $scope.appointments.filter(t=>!$scope.pastAppointments.some(m=>m.patient_appointment_id === t.patient_appointment_id)).sort((a,b)=>moment.utc(a.start_date_utc) - moment.utc(b.start_date_utc));
		}

		// The IANA zone of an appointment's practice, worked out as the calendar does it: the practice's own
		// zone, then the one being worked in, then UTC. The list spans every practice the user belongs to, so
		// the browser's clock is not a stand-in - an Australian booking read on a NZ machine came out hours out.
		function timezoneNameOf(raw) {
			const candidate = raw && TIMEZONE_TYPE.find((zone) => zone.value === raw || zone.name === raw);
			if (candidate && moment.tz.zone(candidate.name)) {
				return candidate.name;
			}
			return raw && moment.tz.zone(raw) ? raw : null;
		}

		function practiceTimezoneName(practiceId) {
			const practice = (Session.practiceOptions || []).find((p) => String(p.id) === String(practiceId));
			return timezoneNameOf(practice && practice.timezone)
				|| timezoneNameOf(Session.practice && Session.practice.timezone)
				|| "UTC";
		}

        $scope.formatText = function (data){
			const category = data.appointment_category?.name ?? 'UNKNOWN';
			const dateTime = moment.utc(data.start_date_utc).tz(practiceTimezoneName(data.practice_id)).format("DD/MM/YYYY HH:mm");
			let seen = '';
			if(data.patient_seen){
				seen = getProgressString(data.patient_seen)
			}

			// The list covers every practice the user belongs to, so name the practice of any
			// appointment that isn't in the one they're working in.
			const practice = Number(data.practice_id) !== Number(Session.practice.id) && data.practice_name ? ` (${data.practice_name})` : '';

			return `${category}: ${dateTime} ${seen} ${data.clinician_name}${practice}`
        }

        $scope.editAppointment = function(appointment){
			$scope.$ctrl.trigger({appointment});
        }

		function getProgressString(seen) {
			if (!seen) {
				return "";
			} 

			let timestamp = null;
			let seen_latest = null;

			if(seen.doctor_started){
				timestamp = new Date(seen.doctor_started_timestamp);
				seen_latest = 'Doctor started';
			}

			if(seen.doctor_finished){
				if(!timestamp || moment(seen.doctor_finished_timestamp).isAfter(moment(timestamp)) ){
					timestamp = new Date(seen.doctor_finished_timestamp);
					seen_latest = 'Doctor finished';
				}
			}

			if(seen.technician_started) {
				if(!timestamp || moment(seen.technician_started_timestamp).isAfter(moment(timestamp)) ){
					timestamp = new Date(seen.technician_started_timestamp);
					seen_latest = 'Technician started';
				}
			}

			if(seen.technician_finished) {
				if(!timestamp || moment(seen.technician_finished_timestamp).isAfter(moment(timestamp)) ){
					timestamp = new Date(seen.technician_finished_timestamp);
					seen_latest = 'Technician finished';
				}
			}

			if(seen.nurse_started) {
				if(!timestamp || moment(seen.nurse_started_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'Nurse started';
					timestamp = new Date(seen.nurse_started_timestamp);
				}
			}

			if(seen.nurse_finished) {
				if(!timestamp || moment(seen.nurse_finished_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'Nurse finished';
					timestamp = new Date(seen.nurse_finished_timestamp);
				}
			}


			if(seen.optometrist_started) {
				if(!timestamp || moment(seen.optometrist_started_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'Optometrist started';
					timestamp = new Date(seen.optometrist_started_timestamp);
				}
			}

			if(seen.optometrist_finished) {
				if(!timestamp || moment(seen.optometrist_finished_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'Optometrist finished';
					timestamp = new Date(seen.optometrist_finished_timestamp);
				}
			}

			if(seen.orthoptist_started) {
				if(!timestamp || moment(seen.orthoptist_started_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'Orthoptist started';
					timestamp = new Date(seen.orthoptist_started_timestamp);
				}
			}

			if(seen.orthoptist_finished) {
				if(!timestamp || moment(seen.orthoptist_finished_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'Orthoptist finished';
					timestamp = new Date(seen.orthoptist_finished_timestamp);
				}
			}

			if(seen.arrived) {
				if(!timestamp || moment(seen.arrived_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'Arrived';
					timestamp = new Date(seen.arrived_timestamp);
				}
			}

			if(seen.departed) {
				if(!timestamp || moment(seen.departed_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'Departed';
					timestamp = new Date(seen.departed_timestamp);
				}
			}

			if(seen.could_not_attend) {
				if(!timestamp || moment(seen.could_not_attend_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'CNA';
					timestamp = new Date(seen.could_not_attend_timestamp);
				}
			}

			if(seen.did_not_attend) {
				if(!timestamp || moment(seen.did_not_attend_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'DNA';
					timestamp = new Date(seen.did_not_attend_timestamp);
				}
			}

			if(seen.rebooked) {
				if(!timestamp || moment(seen.rebooked_timestamp).isAfter(moment(timestamp)) ){
					seen_latest = 'Rebooked';
					timestamp = new Date(seen.rebooked_timestamp);
				}
			}

			if(seen_latest && timestamp){
				return `(${seen_latest}: ${$filter("date")(new Date(timestamp), "HH:mm")})`
			}
			return "";
		}
	},
]);
